import React from "react";
import _ from "lodash";
import isSelectingText from "Utils/isSelectingText";
import PropTypes from "prop-types";
import DropdownMenu from "react-dd-menu";
import DetailInfo from "Components/detailInfo/DetailInfo";
import ButtonIcon from "Components/buttonIcon/ButtonIcon";
import TranslatedString from "Components/TranslatedString";
import t from "Utils/translation";
import { Icon, user, trash, enable, disable, more } from "Icons/index";

import cx from "classnames";
import s from "./delegateCard.scss";

const ContextTypes = {
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func
};

export default class DelegateCard extends React.PureComponent {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.destroy = this.destroy.bind(this);
    this.close = this.close.bind(this);
    this.state = {
      isMenuOpen: false
    };
  }

  toggle(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  }

  close() {
    this.setState({ isMenuOpen: false });
  }

  destroy(e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.delete(this.props.code);
  }

  render() {
    let changeStatusButton;

    const {
      status,
      company,
      code,
      showDelegate,
      firstname,
      lastname,
      email_accounts,
      is_customer_disabled,
      canEnableDelegate,
      canManageDelegate
    } = this.props;

    const { isMobileDevice, isMediaMobile, isMediaSM, isMediaMD, isMediaLG } = this.context;

    if (status === "enabled") {
      changeStatusButton = (
        <li
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            this.props.changeDelegateStatus(code, "disabled", is_customer_disabled);
          }}
        >
          <a>
            <Icon svg={disable} />
            <div>{t("ddMenu.disable")}</div>
          </a>
        </li>
      );
    } else {
      changeStatusButton = (
        <li
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            this.props.changeDelegateStatus(code, "enabled", is_customer_disabled);
          }}
        >
          <a>
            <Icon svg={enable} />
            <div>{t("ddMenu.enable")}</div>
          </a>
        </li>
      );
    }

    const hideMenu = !canEnableDelegate && !canManageDelegate;

    return (
      <div
        className={s.card}
        onClick={() => {
          if (!isSelectingText()) {
            showDelegate(code);
          }
        }}
      >
        <div className={cx(s.statusCircle, { [s[status]]: true })}>
          <Icon className={s.iconUser} svg={user} width="0.75rem" height="0.75rem" />
        </div>

        <div className={s.name}>{`${firstname} ${lastname}`}</div>

        <div className={s.info}>
          <DetailInfo
            className={s.detailInfo}
            label={t("detailInfo.label.code")}
            info={code}
            inLine
          />
          {company && (
            <DetailInfo
              className={s.detailInfo}
              label={t("detailInfo.label.company")}
              info={company}
              inLine
            />
          )}
        </div>

        <DropdownMenu
          isOpen={this.state.isMenuOpen}
          animate={false}
          close={this.close}
          toggle={
            hideMenu ? "" : <ButtonIcon className={s.ddMenu} icon={more} onClick={this.toggle} />
          }
          align="right"
        >
          {canEnableDelegate && changeStatusButton}
          {canManageDelegate && (
            <li onClick={this.destroy}>
              <a>
                <Icon svg={trash} />
                <div>{t("ddMenu.delete")}</div>
              </a>
            </li>
          )}

          {isMediaMobile() && (
            <li className="cancelBtn">
              <a>
                <div>{t("ddMenu.cancel")}</div>
              </a>
            </li>
          )}
        </DropdownMenu>
      </div>
    );
  }
}

DelegateCard.contextTypes = ContextTypes;
